<template>
<div class="rewards">
    <div class="top-section w-full h-full mb-4">
        <div class="flex justify-between px-4 py-4">
            <div class="sm:flex sm:justify-between w-full items-start md:block left text-center sm:text-left">
                <h5 class="text-2xl md:text-4xl font-bold mb-5">
                    Course Certificates
                </h5>
                <lms-button color="#fff" class="text-center mr-2" @click="$router.push({ name: 'tenant-certificate-add' })">Create Certificates</lms-button>

                <a download class="link__btn py-2 px-8 rounded" target="_blank" href="https://edc-lms-public-images.s3-eu-west-2.amazonaws.com/files/TNY+Certificate_.pdf">Download Template</a>
            </div>
            <div class="hidden md:block right">
                <img src="https://res.cloudinary.com/lms-edc/image/upload/v1594517172/Assets/chovh7jpbkgd4ixmc2fn.png" alt="" />
            </div>
        </div>
    </div>
    <router-view />
</div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from "vuex";
export default {
    components: {
        LmsButton: () => import("@/components/general/button"),
        lcontainer: () => import("@/components/general/container"),
    },
    methods: {},
};
</script>

<style lang="scss">
.link__btn {
    color: color(lms-tenant) !important;
    background-color: #fff;
    font-weight: 600;
}

.rewards {
    .top-section {
        background: linear-gradient(61deg, color(lms-tenant), #fff 100%);

        h5 {
            color: #fff !important;
        }

        button {
            color: color(lms-tenant) !important;
        }
    }

    .home,
    .details {
        background-color: #fff;
    }

    .create {
        background-color: #fff;

        .import {
            color: color(lms-tenant);
        }
    }
}

.page-heading {
    color: color(lms-tenant);
}
</style>
